import GlobalMenu from 'components/GlobalMenu/GlobalMenu'
import ROUTE from 'constant/route'
import LoginPage from 'pages/LoginPage/LoginPage'
import { Suspense } from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import SplashScreenPage from 'pages/SplashPage'
import ForgetPage from 'pages/ForgetPasswordPage'
import RegisterDevicePage from 'pages/RegisterDevicePage/RegisterDevicePage'
import RequestResetPasswordPage from 'pages/ResetPasswordPage/RequestResetPasswordPage'
import ResetPasswordPage from 'pages/ResetPasswordPage/ResetPassword'
import LogoutPage from 'pages/LogoutPage/LogoutPage'

function NoClientRouter() {
    return (
        <Suspense fallback={<SplashScreenPage />}>
            <GlobalMenu />
            <Switch>
                <Redirect exact from={ROUTE.MAIN} to={ROUTE.SELECT_DEVICE} />
                <Route
                    exact
                    path={ROUTE.RESET_PASSWORD}
                    render={() => {
                        return <ResetPasswordPage />
                    }}
                />
                <Route
                    path={ROUTE.SELECT_DEVICE}
                    render={() => {
                        return <RegisterDevicePage />
                    }}
                />
                <Route exact path={ROUTE.FORGET} component={ForgetPage} />
                <Route exact path={ROUTE.LOGIN} component={LoginPage} />
                <Route exact path={ROUTE.LOGOUT} component={LogoutPage} />
                <Route
                    exact
                    path={ROUTE.REQUEST_RESET_PASSWORD}
                    render={() => {
                        return <RequestResetPasswordPage />
                    }}
                />
                {/* when use other path, always redirect to select device */}
                <Redirect to={ROUTE.SELECT_DEVICE} />
            </Switch>
        </Suspense>
    )
}

export default NoClientRouter
